import styles from './styles.module.scss';
import { solutionsCardProps } from './props';
import useTranslation from 'next-translate/useTranslation';
import { Animation, Image } from '@starsoft/common/components';
import { useIsMobile } from '@starsoft/common/hooks';

export default function HomeSolutionsCard({
  icon,
  title,
  subtitle,
}: solutionsCardProps) {
  const { t } = useTranslation('common');

  const isMobile = useIsMobile();

  function animationType() {
    if (isMobile) {
      return 'fadeInRight';
    }
    return 'fadeInUp';
  }

  return (
    <Animation type={animationType()}>
      <div className={styles.content} data-theme="dark">
        <div className={styles.content__icon}>
          <Image src={icon} />
        </div>
        <div className={styles.content__info}>
          <div className={styles.content__info__title}>{t(title)}</div>
          <div className={styles.content__info__subtitle}>{t(subtitle)}</div>
        </div>
      </div>
    </Animation>
  );
}
